import React, {Component} from 'react';

import SezioneUno from './SezioneUno'
import SezioneDue from './SezioneDue';
import SezioneTre from './SezioneTre';
import SezioneQuattro from './SezioneQuattro';
import SezioneCinque from './SezioneCinque';
import SezioneSei from './SezioneSei';
import SezioneSette from './SezioneSette';
import SezioneOtto from './SezioneOtto';
import SezioneNove from './SezioneNove';
import SezioneUndici from './SezioneUndici';
import SezioneDodici from './SezioneDodici';
import SezioneTredici from './SezioneTredici';
import SezioneDieci from './SezioneDieci';
import Utils from "../../../../../../utils/Utils";
import ToasterSingleton from "../../../../../../singleton/ToasterSingleton";
import toasterConfig from "../../../../../../config/toasterConfig";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";


export default class SchedaSpecialeEpatite extends Component {


    state = {
        schedaSpecialeEpatite: {
            sezioneUno: {},
            sezioneDue: {},
            sezioneTre: {},
            sezioneQuattro: {},
            sezioneCinque: {},
            sezioneSei: {},
            sezioneSette: {},
            sezioneOtto: {},
            sezioneNove: {},
            sezioneDieci: {},
            sezioneUndici: {},
            sezioneDodici: {},
            sezioneTredici: {}
        },
        oggettoBackend: {
            sezioneUno: {},
            sezioneDue: {},
            sezioneTre: {},
            sezioneQuattro: {},
            sezioneCinque: {},
            sezioneSei: {},
            sezioneSette: {},
            sezioneOtto: {},
            sezioneNove: {},
            sezioneDieci: {},
            sezioneUndici: {},
            sezioneDodici: {},
            sezioneTredici: {}
        },
        validateEpatite: {
            sezioneDue: "",
            sezioneTre: "",
            sezioneQuattro: "",
            sezioneCinque: "",
            sezioneSei: "",
            sezioneSette: "",
            sezioneUndici: "",
            sezioneDodici: "",
        },
        corretto: []

    }

    constructor(props) {
        super(props);
        this.setSezioneUno = this.setSezioneUno.bind(this);
        this.setSezioneDue = this.setSezioneDue.bind(this);
        this.setSezioneTre = this.setSezioneTre.bind(this);
        this.setSezioneQuattro = this.setSezioneQuattro.bind(this);
        this.setSezioneCinque = this.setSezioneCinque.bind(this);
        this.setSezioneSei = this.setSezioneSei.bind(this);
        this.setSezioneSette = this.setSezioneSette.bind(this);
        this.setSezioneOtto = this.setSezioneOtto.bind(this);
        this.setSezioneNove = this.setSezioneNove.bind(this);
        this.setSezioneDieci = this.setSezioneDieci.bind(this);
        this.setSezioneUndici = this.setSezioneUndici.bind(this);
        this.setSezioneDodici = this.setSezioneDodici.bind(this);
        this.setSezioneTredici = this.setSezioneTredici.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.validate = this.validate.bind(this);

    }

    componentDidMount() {
        this.props.setSchedaSpecialeECorretto(this.state.oggettoBackend)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let corretto = this.controlloDati();
        if (prevState !== this.state) {
            let objFinal = this.createJsonForBackend()
            this.props.setSchedaSpecialeECorretto(objFinal, this.validate(), corretto)
        }
    }

    validate() {
        let validate = this.state.validateEpatite

        for (let key in validate) {
            if (validate[key]) {
                return validate[key]
            }
        }

        return ""
    }

    aggiungiToaster(text) {

        ToasterSingleton.instance().aggiuntaToaster(
            {
                type: toasterConfig.types.confirm,
                text: text,
                timestamp: Date.now()
            });
    }

    controlloDati(){
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        let textList = []

        if(schedaSpecialeEpatite.sezioneUno.corretto && schedaSpecialeEpatite.sezioneUno.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneUno.corretto))
        }
        if(schedaSpecialeEpatite.sezioneDue.corretto && schedaSpecialeEpatite.sezioneDue.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneDue.corretto))
        }
        if(schedaSpecialeEpatite.sezioneTre.corretto && schedaSpecialeEpatite.sezioneTre.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneTre.corretto))
        }
        if(schedaSpecialeEpatite.sezioneQuattro.corretto && schedaSpecialeEpatite.sezioneQuattro.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneQuattro.corretto))
        }
        if(schedaSpecialeEpatite.sezioneCinque.corretto && schedaSpecialeEpatite.sezioneCinque.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneCinque.corretto))
        }
        if(schedaSpecialeEpatite.sezioneSei.corretto && schedaSpecialeEpatite.sezioneSei.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneSei.corretto))
        }
        if(schedaSpecialeEpatite.sezioneSette.corretto && schedaSpecialeEpatite.sezioneSette.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneSette.corretto))
        }
        if(schedaSpecialeEpatite.sezioneOtto.corretto && schedaSpecialeEpatite.sezioneOtto.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneOtto.corretto))
        }
        if(schedaSpecialeEpatite.sezioneNove.corretto && schedaSpecialeEpatite.sezioneNove.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneNove.corretto))
        }
        if(schedaSpecialeEpatite.sezioneUndici.corretto && schedaSpecialeEpatite.sezioneUndici.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneUndici.corretto))
        }
        if(schedaSpecialeEpatite.sezioneDodici.corretto && schedaSpecialeEpatite.sezioneDodici.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatite.sezioneDodici.corretto))
        }

        return textList
    }

    createJsonForBackend() {
        let ObjectForBackEnd = {}
        ObjectForBackEnd = Object.assign({}, Utils.removeFieldFromObject(this.state.oggettoBackend, "corretto"))
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;

    }

    setSezioneUno(sezioneUno, oggetto) {

        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneUno = sezioneUno
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneUno = oggetto
        if (sezioneUno && oggetto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, oggettoBackend: oggettiBackend})
        } else if (!sezioneUno && oggetto) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (sezioneUno && !oggetto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        }
    }

    setSezioneDue(sezioneDue, validateDue, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneDue = sezioneDue
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneDue = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneDue = validateDue

        if (sezioneDue && oggetto && validateDue) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneDue && oggetto && validateDue) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneDue && !oggetto && validateDue) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneDue && oggetto && !validateDue) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneDue && !oggetto && validateDue) {
            this.setState({validateEpatite: validate})
        } else if (sezioneDue && !oggetto && !validateDue) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneDue && oggetto && !validateDue) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneTre(sezioneTre, validateTre, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneTre = sezioneTre
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneTre = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneTre = validateTre

        if (sezioneTre && oggetto && validateTre) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneTre && oggetto && validateTre) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneTre && !oggetto && validateTre) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneTre && oggetto && !validateTre) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneTre && !oggetto && validateTre) {
            this.setState({validateEpatite: validate})
        } else if (sezioneTre && !oggetto && !validateTre) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneTre && oggetto && !validateTre) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneQuattro(sezioneQuattro, validateQuattro, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneQuattro = sezioneQuattro
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneQuattro = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneQuattro = validateQuattro

        if (sezioneQuattro && oggetto && validateQuattro) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneQuattro && oggetto && validateQuattro) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneQuattro && !oggetto && validateQuattro) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneQuattro && oggetto && !validateQuattro) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneQuattro && !oggetto && validateQuattro) {
            this.setState({validateEpatite: validate})
        } else if (sezioneQuattro && !oggetto && !validateQuattro) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneQuattro && oggetto && !validateQuattro) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneCinque(sezioneCinque, validateSezioneCinque, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneCinque = sezioneCinque
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneCinque = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneCinque = validateSezioneCinque

        if (sezioneCinque && oggetto && validateSezioneCinque) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneCinque && oggetto && validateSezioneCinque) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneCinque && !oggetto && validateSezioneCinque) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneCinque && oggetto && !validateSezioneCinque) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneCinque && !oggetto && validateSezioneCinque) {
            this.setState({validateEpatite: validate})
        } else if (sezioneCinque && !oggetto && !validateSezioneCinque) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneCinque && oggetto && !validateSezioneCinque) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneSei(sezioneSei, validateSei, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneSei = sezioneSei
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneSei = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneSei = validateSei

        if (sezioneSei && oggetto && validateSei) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneSei && oggetto && validateSei) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneSei && !oggetto && validateSei) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneSei && oggetto && !validateSei) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneSei && !oggetto && validateSei) {
            this.setState({validateEpatite: validate})
        } else if (sezioneSei && !oggetto && !validateSei) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneSei && oggetto && !validateSei) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneSette(sezioneSette, validateSette, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneSette = sezioneSette
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneSette = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneSette = validateSette

        if (sezioneSette && oggetto && validateSette) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneSette && oggetto && validateSette) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneSette && !oggetto && validateSette) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneSette && oggetto && !validateSette) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneSette && !oggetto && validateSette) {
            this.setState({validateEpatite: validate})
        } else if (sezioneSette && !oggetto && !validateSette) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneSette && oggetto && !validateSette) {
            this.setState({oggettoBackend: oggettiBackend})
        }

    }

    setSezioneOtto(sezioneOtto, validateOtto, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneOtto = sezioneOtto
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneOtto = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneOtto = validateOtto

        if (sezioneOtto && oggetto && validateOtto) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneOtto && oggetto && validateOtto) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneOtto && !oggetto && validateOtto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneOtto && oggetto && !validateOtto) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneOtto && !oggetto && validateOtto) {
            this.setState({validateEpatite: validate})
        } else if (sezioneOtto && !oggetto && !validateOtto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneOtto && oggetto && !validateOtto) {
            this.setState({oggettoBackend: oggettiBackend})
        }

    }

    setSezioneNove(sezioneNove, validateNove, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneNove = sezioneNove
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneNove = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneNove = validateNove

        if (sezioneNove && oggetto && validateNove) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneNove && oggetto && validateNove) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneNove && !oggetto && validateNove) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneNove && oggetto && !validateNove) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneNove && !oggetto && validateNove) {
            this.setState({validateEpatite: validate})
        } else if (sezioneNove && !oggetto && !validateNove) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneNove && oggetto && !validateNove) {
            this.setState({oggettoBackend: oggettiBackend})
        }

    }

    setSezioneDieci(sezioneDieci, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneDieci = sezioneDieci
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneDieci = oggetto
        if (sezioneDieci && oggetto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, oggettoBackend: oggettiBackend})
        } else if (!sezioneDieci && oggetto) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (sezioneDieci && !oggetto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        }
    }

    setSezioneUndici(sezioneUndici, validateUndici, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneUndici = sezioneUndici
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneUndici = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneUndici = validateUndici

        if (sezioneUndici && oggetto && validateUndici) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneUndici && oggetto && validateUndici) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneUndici && !oggetto && validateUndici) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneUndici && oggetto && !validateUndici) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneUndici && !oggetto && validateUndici) {
            this.setState({validateEpatite: validate})
        } else if (sezioneUndici && !oggetto && !validateUndici) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneUndici && oggetto && !validateUndici) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneDodici(sezioneDodici, validateDodici, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneDodici = sezioneDodici
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneDodici = oggetto
        let validate = this.state.validateEpatite
        validate.sezioneDodici = validateDodici

        if (sezioneDodici && oggetto && validateDodici) {
            this.setState({
                schedaSpecialeEpatite: schedaSpecialeEpatite,
                oggettoBackend: oggettiBackend,
                validateEpatite: validate
            })
        } else if (!sezioneDodici && oggetto && validateDodici) {
            this.setState({oggettoBackend: oggettiBackend, validateEpatite: validate})
        } else if (sezioneDodici && !oggetto && validateDodici) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, validateEpatite: validate})
        } else if (sezioneDodici && oggetto && !validateDodici) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneDodici && !oggetto && validateDodici) {
            this.setState({validateEpatite: validate})
        } else if (sezioneDodici && !oggetto && !validateDodici) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        } else if (!sezioneDodici && oggetto && !validateDodici) {
            this.setState({oggettoBackend: oggettiBackend})
        }
    }

    setSezioneTredici(sezioneTredici, oggetto) {
        let schedaSpecialeEpatite = this.state.schedaSpecialeEpatite
        schedaSpecialeEpatite.sezioneTredici = sezioneTredici
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.sezioneTredici = oggetto
        if (sezioneTredici && oggetto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite, oggettoBackend: oggettiBackend})
        } else if (!sezioneTredici && oggetto) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (sezioneTredici && !oggetto) {
            this.setState({schedaSpecialeEpatite: schedaSpecialeEpatite})
        }
    }

    render() {

        return (<div
            className={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
            <fieldset
                disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>

                <SezioneUno
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneUno={this.setSezioneUno}
                />
                <SezioneDue
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    datiPaziente={this.props.datiPaziente}
                    setSezioneDue={this.setSezioneDue}
                />
                <SezioneTre
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneTre={this.setSezioneTre}
                />
                <SezioneQuattro
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneQuattro={this.setSezioneQuattro}
                />
                <SezioneCinque
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneCinque={this.setSezioneCinque}
                    aggiungiToaster={this.aggiungiToaster}
                />
                <SezioneSei
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneSei={this.setSezioneSei}
                />
                <SezioneSette
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneSette={this.setSezioneSette}
                />
                <SezioneOtto
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneOtto={this.setSezioneOtto}
                />
                <SezioneNove
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneNove={this.setSezioneNove}
                />
                <SezioneDieci
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneDieci={this.setSezioneDieci}
                />
                <SezioneUndici
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneUndici={this.setSezioneUndici}
                />
                <SezioneDodici
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneDodici={this.setSezioneDodici}
                />
                <SezioneTredici
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setSezioneTredici={this.setSezioneTredici}
                />
            </fieldset>
        </div>)
    }


}
